import React, { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { FACE_RAW_ORDER } from "../utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// 🔁 Lazy-load pages
const FaceInventoryList = lazy(() => import("app/pages/Inventory/Face Inventory/ListFace"));
const AddFaceStock = lazy(() => import("app/pages/Inventory/Face Inventory/AddFace"));
const EditFaceStock = lazy(() => import("app/pages/Inventory/Face Inventory/EditFace"));
const ViewDetails = lazy(() => import("app/pages/Inventory/Face Inventory/ListFace/Approval/ViewDetails"));
const IssueRawOrderFace = lazy(() => import("app/pages/Inventory/Face Inventory/IssueRawOrder"));

export const faceInventoryRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "face_inventory", "view"],
      },
    ],
    routes: [
      {
        path: "/inventory/face",
        element: LoadablePage(FaceInventoryList),
      },
      {
        path: "/inventory/face/add",
        element: LoadablePage(AddFaceStock),
      },
      {
        path: "/inventory/face/edit",
        element: LoadablePage(EditFaceStock),
      },
      {
        path: "/inventory/face-approval/view-details/:id/:invoiceId",
        element: LoadablePage(ViewDetails),
      },
      {
        path: FACE_RAW_ORDER,
        element: LoadablePage(IssueRawOrderFace),
      },
    ],
  },
];
